<div class="modal-header">
    <h4
        class="modal-title"
        id="modal-title"
    >
      {{this.launchType() === 'relaunch' ? 'Schedule ReLaunch' : 'Schedule Launch'}}
    </h4>
    <div class="d-flex justify-content-end">
        <button
            type="button"
            aria-label="Close button"
            class="btn-close"
            aria-describedby="modal-title"
            (click)="modal.close()"
        ></button>
    </div>
</div>

<div class="modal-body">
    <form [formGroup]="form">
        <div class="row">
            <div class="col-md-12">
                <div>Choose the date and time you want the campaign to be launched</div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="calendar">
                            <app-sb-input-time type="date" valueAs="date" formControlName="schedule_date" label="Date"
                                [required]="true" [min]="min" [timeZone]="timezoneName()" [error]="dateError()"></app-sb-input-time>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="Time">
                            <app-sb-input-time type="time" formControlName="schedule_time" label="Time"
                                [required]="true" [timeZone]="timezoneName()" [joinsDate]="true" [error]="timeError()"
                                (dayPicked)="onTimePickDay($event)"></app-sb-input-time>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12" style="margin-top: 10px">
                        <div class="floating-label">
                            <i
                                aria-hidden="true"
                                class="fa fa-angle-down chevronSelectOptionIcon"
                            ></i>
                          <app-timezone-picker class="dropdown-panel-timezone" [setDefaultValue]="form.get('timezone').value" (formControlValue)="getTimezoneValue($event)" [customPlaceholderText]="'Time Zone'" [isClearable]='true'></app-timezone-picker>
                            <span class="highlight"></span>
                        </div>
                        @if (form.get('timezone').invalid && (form.get('timezone').dirty || form.get('timezone').touched)) {
                        <div class="text-danger small">
                            Timezone is required
                        </div>
                        }
                    </div>
                </div>

                <!-- API Sync Options -->
                @if (hasActiveRegistrationPlatforms()) {
                <div style="margin-top: 30px; padding-top: 25px; padding-bottom: 10px; border-top: 1px solid #dee2e6;">
                    <div class="row" style="margin-bottom: 18px;">
                        <div class="col-md-12">
                            <div class="form-check form-check-native">
                                <input 
                                    class="form-check-input" 
                                    type="checkbox" 
                                    formControlName="sync_influencers_before_launch"
                                    id="syncInfluencersCheckbox"
                                >
                                <label class="form-check-label" for="syncInfluencersCheckbox" style="cursor: pointer;">
                                    Sync influencers before launch
                                </label>
                            </div>
                        </div>
                    </div>

                    @if (form.get('sync_influencers_before_launch').value) {
                    <div>
                        <!-- Registration Platform Selection -->
                        @if (activePlatforms.length > 0) {
                        <div class="row" style="margin-bottom: 25px;">
                            <div class="col-md-12">
                                <label for="platformSelect" style="font-weight: 500; margin-bottom: 10px; display: block;">
                                    Select API integration to sync:
                                </label>
                                <ng-select
                                    class="dropdown-panel-timezone5"
                                    formControlName="sync_project_registration_platform_id"
                                    [items]="activePlatforms"
                                    bindLabel="name"
                                    bindValue="id"
                                    placeholder="-- Select a platform --"
                                    [clearable]="true"
                                >
                                </ng-select>
                                @if (form.get('sync_project_registration_platform_id').invalid && (form.get('sync_project_registration_platform_id').dirty || form.get('sync_project_registration_platform_id').touched)) {
                                <div class="text-danger small mt-1">
                                    API integration is required
                                </div>
                                }
                            </div>
                        </div>
                        }

                        <div class="row" style="margin-bottom: 20px;">
                            <div class="col-md-12">
                                <div class="form-check form-check-native">
                                    <input 
                                        class="form-check-input" 
                                        type="checkbox" 
                                        formControlName="require_successful_sync"
                                        id="requireSuccessCheckbox"
                                        [disabled]="!form.get('sync_influencers_before_launch').value"
                                    >
                                    <label class="form-check-label" for="requireSuccessCheckbox" style="cursor: pointer;">
                                        Launch the campaign only if the sync was successful
                                    </label>
                                </div>
                            </div>
                        </div>

                        <div class="row" style="margin-bottom: 20px;">
                            <div class="col-md-12">
                                <label for="syncHoursSelect" style="font-weight: 500; margin-bottom: 10px; display: block;">
                                    How many hours before launch should the sync start?
                                </label>
                                <ng-select
                                    class="dropdown-panel-timezone"
                                    formControlName="sync_hours_before_launch"
                                    [items]="formattedSyncHoursOptions"
                                    bindLabel="label"
                                    bindValue="value"
                                    placeholder="Select hours"
                                    [clearable]="true"
                                >
                                </ng-select>
                                @if (form.get('sync_hours_before_launch').invalid && (form.get('sync_hours_before_launch').dirty || form.get('sync_hours_before_launch').touched)) {
                                <div class="text-danger small mt-1">
                                    Sync hours before launch is required
                                </div>
                                }
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <small class="form-text text-muted" style="display: block; line-height: 1.6;">
                                    API sync can take from minutes to hours depending on the number of influencers. 
                                    It's recommended to set it to sync 12 hours before launch.
                                </small>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                }

                <!-- Sync and push after launch: pushes the share links the launch creates -->
                @if (hasPushRegistrationPlatforms()) {
                <div class="launch-schedule__after-launch">
                    <div class="row" style="margin-bottom: 18px;">
                        <div class="col-md-12">
                            <div class="form-check form-check-native">
                                <input
                                    class="form-check-input"
                                    type="checkbox"
                                    formControlName="sync_influencers_after_launch"
                                    id="syncAfterLaunchCheckbox"
                                >
                                <label class="form-check-label" for="syncAfterLaunchCheckbox" style="cursor: pointer;">
                                    Sync and push after launch
                                </label>
                            </div>
                        </div>
                    </div>

                    @if (form.get('sync_influencers_after_launch').value) {
                    <div>
                        <div class="row" style="margin-bottom: 20px;">
                            <div class="col-md-12">
                                <label for="afterLaunchPlatformSelect" style="font-weight: 500; margin-bottom: 10px; display: block;">
                                    Select API integration to sync and push to:
                                </label>
                                <ng-select
                                    class="dropdown-panel-timezone5"
                                    labelForId="afterLaunchPlatformSelect"
                                    formControlName="sync_after_launch_registration_platform_id"
                                    [items]="pushPlatforms"
                                    bindLabel="name"
                                    bindValue="id"
                                    placeholder="-- Select a platform --"
                                    [clearable]="true"
                                >
                                </ng-select>
                                @if (form.get('sync_after_launch_registration_platform_id').invalid && (form.get('sync_after_launch_registration_platform_id').dirty || form.get('sync_after_launch_registration_platform_id').touched)) {
                                <div class="text-danger small mt-1">
                                    API integration is required
                                </div>
                                }
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <small class="form-text text-muted launch-schedule__after-launch-hint" style="display: block; line-height: 1.6;">
                                    Once the campaign has launched, the platform is synced and the new share links are pushed to it.
                                    Campaigns launching at the same time share one sync.
                                </small>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                }
            </div>
        </div>
    </form>
</div>
<input
    type="hidden"
    ngbAutofocus
>
<div class="modal-footer">
    <button
        class="btn"
        type="button"
        (click)="close()"
    >
        Cancel
    </button>
    <button
        class="btn btn-primary"
        type="button"
        (click)="save()"
    >
        Save
    </button>
</div>
